import { type ZodArray, type ZodObject, type ZodOptional, type ZodType, type ZodUnion } from "zod";

export function getValidationPropertyType(
  schema: ZodObject,
  dottedKey: string,
): "string[]" | "number[]" | "string" | "number" {
  const parts = dottedKey.split(".");
  let propertySchema: ZodType = schema;

  for (const property of parts) {
    propertySchema = handleInnerType(propertySchema);
    if (propertySchema.def.type === "object") {
      propertySchema = (propertySchema as ZodObject).def.shape[property];
    } else if (propertySchema.def.type === "union") {
      const propertyOption = (propertySchema as ZodUnion).options.find(
        (option) => (option as ZodObject).def.shape[property],
      ) as ZodObject;
      propertySchema = propertyOption.def.shape[property];
    }
  }
  propertySchema = handleInnerType(propertySchema);
  if (propertySchema.type === "array") {
    return ((propertySchema as ZodArray).element as ZodType).type === "number"
      ? "number[]"
      : "string[]";
  }
  return propertySchema.type === "number" ? "number" : "string";
}

function handleInnerType(propertySchema: ZodType): ZodType {
  if ("innerType" in (propertySchema as ZodOptional).def) {
    return (propertySchema as ZodOptional).def.innerType as ZodType;
  }
  return propertySchema;
}
